import(/* webpackMode: "eager", webpackExports: ["CoverageSection"] */ "/var/www/turivana/frontend/src/components/CoverageSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTACard"] */ "/var/www/turivana/frontend/src/components/CTACard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperiencesSection"] */ "/var/www/turivana/frontend/src/components/ExperiencesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/var/www/turivana/frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/var/www/turivana/frontend/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroCarousel"] */ "/var/www/turivana/frontend/src/components/HeroCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyUsSection"] */ "/var/www/turivana/frontend/src/components/WhyUsSection.tsx");
